/**
 * Lobby / desk PDF QR — same generators as Skin Routine & Hair Insight, keyed by session id.
 */
import {
  readStoredFranchiseBrandLogo,
  readStoredFranchiseBrandName,
} from '../../shared/franchiseBrand';
import { createSalonReportPdfDownloadUrl } from './salonReportPdfQr';
import {
  buildSalonStoredHairInsightPdfUrl,
  createInsightReportPdfDownloadUrl,
} from '../../../hair-analyzer/src/hair/utils/insightApi';

export function isHairInsightSessionId(sessionId) {
  return String(sessionId || '').trim().toUpperCase().startsWith('HA-');
}

export async function createLobbySkinReportPdfUrl(sessionId, guestName = 'Guest') {
  const sid = String(sessionId || '').trim();
  if (!sid || isHairInsightSessionId(sid)) {
    throw new Error('Enter a valid skin analysis session id');
  }
  const orgName = readStoredFranchiseBrandName() || null;
  const orgLogoUrl = readStoredFranchiseBrandLogo() || null;
  return createSalonReportPdfDownloadUrl({
    session_id: sid,
    use_stored_report: true,
    name: guestName || 'Guest',
    org_name: orgName,
    org_logo_url: orgLogoUrl,
  });
}

export async function createLobbyHairReportPdfUrl(hairSessionId, guestName = 'Guest') {
  const sid = String(hairSessionId || '').trim();
  if (!sid.startsWith('HA-')) {
    throw new Error('Enter a valid Hair Insight session id (HA-…)');
  }
  const stored = buildSalonStoredHairInsightPdfUrl(sid);
  if (stored) return stored;
  const orgName = readStoredFranchiseBrandName() || null;
  const orgLogoUrl = readStoredFranchiseBrandLogo() || null;
  return createInsightReportPdfDownloadUrl(
    {
      sessionId: sid,
      orgName,
      orgLogoUrl,
    },
    sid,
  );
}
